import { Box, SxProps, Typography } from '@mui/material';
import { StrengthWeaknessGroup } from '../../StrengthWeaknessGroup';
import { StrengthWeaknessItem } from '../performanceDrawerData';
import { pxToRem } from '@geneo2-web/shared-ui';

const drawerStyles = {
  card: {
    backgroundColor: '#fff',
    // boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
};
export const StrengthWeaknessSection = ({
  strengths,
  weaknesses,
  mode = 'overall',
  cardHeadingSx = {},
}: {
  strengths?: StrengthWeaknessItem[];
  weaknesses?: StrengthWeaknessItem[];
  mode?: 'overall' | 'session';
  cardHeadingSx?: SxProps;
}) => {
  return (
    <Box sx={drawerStyles.card}>
      {/* HEADER */}
      <Box sx={drawerStyles.cardHeader}>
        <Typography>💡</Typography>
        <Typography
          variant="cardText"
          sx={{
            fontFamily: 'Poppins',
            color: '#1e293b',
            ...cardHeadingSx,
          }}
        >
          {mode === 'session'
            ? 'Session Strengths & Weaknesses'
            : 'Strengths & Weaknesses'}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gap={pxToRem(10)}
        mt={pxToRem(14)}
      >
        <StrengthWeaknessGroup
          title="Strengths"
          icon="💪"
          items={strengths}
          variant="strengths"
          emptyState={'Keep practicing to uncover your strengths!'}
        />

        <StrengthWeaknessGroup
          title="Needs Improvement"
          icon="🎯"
          items={weaknesses}
          variant="weaknesses"
          emptyState={'No weak areas detected in this session!'}
        />
      </Box>
    </Box>
  );
};
